import { createMemoryHistory as createHistory } from 'history';

export default createHistory();
